import { arrayRemove, arrayUnion, doc, onSnapshot, setDoc } from 'firebase/firestore';
import { db } from '@/services/firebase';

const FIELD = 'chatHandshakeIgnoreInviteTokens';
const MAX_IGNORE = 200;

function normalizeList(raw: unknown): string[] {
  if (!Array.isArray(raw)) return [];
  return raw.filter((x): x is string => typeof x === 'string' && x.length > 0).slice(0, MAX_IGNORE);
}

export function subscribeHandshakeIgnoreSet(
  uid: string,
  onUpdate: (set: Set<string>) => void
): () => void {
  if (!uid) {
    onUpdate(new Set());
    return () => {};
  }
  const ref = doc(db, 'users', uid);
  return onSnapshot(
    ref,
    (snap) => {
      const d = snap.exists() ? (snap.data() as Record<string, unknown>)[FIELD] : undefined;
      onUpdate(new Set(normalizeList(d)));
    },
    () => onUpdate(new Set())
  );
}

export async function addHandshakeIgnoreInviteToken(uid: string, inviteToken: string): Promise<void> {
  if (!uid || !inviteToken.trim()) return;
  await setDoc(
    doc(db, 'users', uid),
    { [FIELD]: arrayUnion(inviteToken.trim()) },
    { merge: true }
  );
}

export async function removeHandshakeIgnoreInviteToken(uid: string, inviteToken: string): Promise<void> {
  if (!uid || !inviteToken.trim()) return;
  await setDoc(
    doc(db, 'users', uid),
    { [FIELD]: arrayRemove(inviteToken.trim()) },
    { merge: true }
  );
}
